export default {
    BaseColor: '#FFF',
    KeyColor: '#444',
    SubColor: '#ececec',
    White: '#fff',
    MainColor: '#048ba8',
    SubColor: '#e18f01',
    Gray: '#e0e0e0',
    Black: '#101010',
    DarkGray: '#757575',
    LightGray:'#F2F2F2',
    True: '#42a804',
    False: '#da2a2a',
    Yellow: '#f3ea00',
}